import React from "react";

const MapRangeChanger = () => {
	return (
		<div id="radius-changer" style={{ margin: 15, minWidth: 200 }}>
			<input 
                type="range" 
                defaultValue={0} 
                style={{ width: "100%" }} 
                min={5}
                max={100}
                onChange={e => {
                    console.log(e.target.value)
                }}
                />
		</div>
	);
};

export default MapRangeChanger;
